import React from "react";
import "./CTA.css";
import { motion } from "framer-motion";
import { images } from "../../constants";
import { gtagSendEvent } from "../../utils/gtaghelper";
import { usePopup } from "../../context/PopupContext";

const CTA = () => {
  const { openPopup } = usePopup();
  return (
    <motion.div
      initial={{
        x: "0%",
        y: -100,
        opacity: 0,
      }}
      whileInView={{
        x: "0%",
        y: 0,
        opacity: 1,
      }}
      transition={{
        duration: 1,
        delay: 0.6,
      }}
      viewport={{ once: true }}
      className="section-padding"
    >
      <div className="row cta">
        <div className="col-lg-8 col-12">
          <h3>Need a custom website quote?</h3>

          <p className="pt-2 pb-4">
             Tell us what you need — we’ll craft the right solution.
          </p>
          <button
            className="btn-positivus"
            onClick={() => openPopup({ source: "CTA — Request Custom Quote" })}
          >
            Request Custom Quote
          </button>
        </div>
        <div className="col-lg-4 d-lg-flex d-none">
          <img src={images.thingshappen} alt="thingshappen" />
        </div>
      </div>
    </motion.div>
  );
};

export default CTA;
